import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { RoomCardDto, CreateRoomRequest } from '../types/community'
import { getOpenRooms, createRoom } from '../lib/api/rooms'
import { usePoll } from './usePoll'

/**
 * "Rooms open now" across the acting person's circles. Polls every 15s while mounted
 * (COTC_Rooms polling transport; SignalR upgrade is tracked debt).
 */
export function useOpenRooms(actingPersonId?: string) {
  const query = useQuery<RoomCardDto[]>({
    queryKey: ['community', 'rooms', 'open', actingPersonId ?? null],
    queryFn: () => getOpenRooms(),
    retry: false,
  })

  usePoll(() => void query.refetch(), 15_000)

  return query
}

/** Open a new monitored lobby (eligible hosts only). Refreshes the open-rooms list on success. */
export function useCreateRoom() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (req: CreateRoomRequest) => createRoom(req),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['community', 'rooms', 'open'] }),
  })
}
